














































































































// lee 服务端不支持搜索和分页，目前自己备份一份数据，进行的分页，触发更新操作的时候调取publish接口，并同时更新vuex中的缓存
// lee 对应proto文件 dialer/nxExtenManage.proto
import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { nxExtenManageClient } from "@/api/nxExtenManageClient";
import {
  XExtenListReq,
  AddExtenPhoneReq,
  AssignExtenPhoneReq,
  UserAssignedListReq,
  OperateNxteleReq,
  DelExtenPhoneReq
} from "@/pbjs/xcommon/nxExtenManage_pb";
import { UnassignReq } from "@/pbjs/xcommon/dialer_pb";
const addNewPhone = () => import("./component/addNewPhone.vue"); //  lee 新增分机号码组件
const assignPhone = () => import("./component/assignPhone.vue"); //  lee 新增分派号码组件
import SupplierJson from "@/doc/Supplier.json"; //  lee 自己存储的供应商json
import { setMetaData, timeFormat, downloadFile } from "@/utils/index"; //  lee 自己存储的供应商json
import { pagnition } from "@/utils/commonConfig";
import { setCommon, errorMsg, setPage, handleResponse } from "@/utils/request";
interface Phone {
  phoneStart?: String;
  phoneEnd?: String;
  nxtele?: String;
  nxname?: String;
}

interface AssignPhoneDialog {
  name?: String;
  email?: String;
  role?: String;
}
@Component({
  name: "CombinationProperty",
  components: {
    addNewPhone,
    assignPhone
  }
})
// 接口请求待优化
export default class CombinationProperty extends Vue {
  @Provide() private country: any = localStorage.getItem("country"); // 国家，字段差异化展示
  @Provide() private assignStateOptions: any = [
    { value: 1, name: "已分配" },
    { value: 2, name: "未分配" }
  ];
  @Provide() private providerOptions: any = [
    {
      id: "1",
      value: "nxtele"
    },
    {
      id: "2",
      value: "infinity"
    }
  ]; // lee 供应商列表
  @Provide() private searchForm: any = {
    ExtNumber: "",
    UserName: "",
    Supplier: "",
    AssignStatus: "",
    AddStartTime: "",
    AddEndTime: "",
    SearchStart: "",
    SearchEnd: "",
    AccountNumber:'',
  }; // lee 搜索表单
  @Provide() private multipleSelection: any = []; // lee 多选数组
  @Provide() private resultData: any = [];
  @Provide() private Supplier: any = "";
  @Provide() private ExtNumber: any = "";
  @Provide() private token: any = "";
  @Provide() private userid: any = "";
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0; // lee 分页参数 目前分页是自己处理的
  @Provide() private MorkResultData: any = [
    {
      Id: 1111,
      ExtNumber: 1111,
      Utime: 1111,
      Supplier: 1111
    }
  ];
  
  @Provide() private symphoneList: any = {}; // lee 模拟数据
  @Provide() private isMorked: boolean = false; // lee 模拟数据
  @Provide() private isAddNewPhone: boolean = false; // lee 是否展示添加分机号码弹窗
  @Provide() private isAssigned: boolean = false; // lee 是否展示分配弹窗
  // @Provide() private isAssignHistory: boolean = false; // lee 是否展示分配历史
  @Provide() private phone: Phone = {
    phoneStart: "",
    phoneEnd: "",
    nxtele: "1",
    nxname: ""
  };
  @Provide() private isSearchFormActionDone: boolean = false;
  @Provide() private pagnition: any = pagnition;
  @Provide() private isExportFormActionDone: boolean = false;

  private created() {
    this.token = localStorage.getItem("token");
    this.userid = localStorage.getItem("userid");
    this.getExtenList(); // 获取列表数据
    this.providerOptions = SupplierJson.list; // 匹配供应商映射list
    // let newSupplier:any = [];
    // SupplierJson.list.map((item:any) => {
    //   newSupplier.push(
    //     {
    //       id: item.id,
    //       value: item.value,
    //       in: item.in,
    //       show: true
    //     }
    //   )     
    // })
    // newSupplier.push({
    //   id: 11,
    //   value: 'calluCloud',
    //   show: this.systemInfo === 'MPEM' ? true : false
    // })
    // this.providerOptions = newSupplier;
  }
  private mounted() {
  }

  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getExtenList();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getExtenList();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getExtenList();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getExtenList();
  }

  //  lee 是否关闭新增弹窗
  private hideDialog(hideObj: any): void {
    this.isAddNewPhone = false;
    if (hideObj.isAdd) {
      this.getExtenList();
    }
  }
  // lee 关闭所有弹窗
  private hideAllDialog() {
    this.isAddNewPhone = false;
    this.isAssigned = false;
  }
  // lee 是否关闭分配弹窗
  private hideAssignPhoneDialog(isHidden: boolean): void {
    this.isAssigned = isHidden;
    this.getExtenList();
  }
  // lee 添加分机号码点击操作
  private addPhone(list:any): void {
    if (list) {
      this.symphoneList=list
    }
    this.isAddNewPhone = true;
  }
  //  lee 刪除分機號碼
  private delExtenPhoneFuc(data: any) {
    this.$message.success("successfully!");
    this.getExtenList();
  }
  private exportAction(): any {
    let _arg: any = {
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      },
      UserName: this.searchForm.UserName,
      Supplier: this.searchForm.Supplier,
      AssignStatus: this.searchForm.AssignStatus,
      ExtNumber: this.searchForm.ExtNumber,
      SearchStart: this.searchForm.SearchStart,
      SearchEnd: this.searchForm.SearchEnd,
    };
    if (this.searchForm.time && this.searchForm.time.length > 0) {
      _arg.AddStartTime = Number(this.searchForm.time[0].getTime())
    }
    if (this.searchForm.time && this.searchForm.time.length > 0) {
      _arg.AddEndTime = Number(this.searchForm.time[1].getTime())
    }
    return _arg;
  }
  // 导出
  private async exportExcel() {
    let _arg: any = this.exportAction();
    const { exportExcelReq, exportExcelRequest }: any = await import(
      "@/request/extensionManagement"
    );
    let response = await exportExcelRequest.handleHttp(
      exportExcelReq(_arg),
      this
    );
    if (response) {
      this.isExportFormActionDone = response ? response.loading : false;
      if (response) {
        if (response.filechunk) {
          let bStr = atob(response.filechunk),
            n = bStr.length,
            unit8Array = new Uint8Array(n);
          while (n--) {
            unit8Array[n] = bStr.charCodeAt(n);
          }
          const blob = new Blob([unit8Array], {
            type: "application/json"
          });
          downloadFile(blob, response.filename);
        }
      }
    }
  }

  private delExtenPhone() {
    if (this.multipleSelection.length > 0) {
      this.$confirm(this.$tc("authority.confirmDelete"), "tips", {
        confirmButtonText: this.$tc("ticket.Sure"),
        cancelButtonText: this.$tc("authority.cancel"),
        type: "warning"
      })
        .then(() => {
          let request: any = new DelExtenPhoneReq();
          request.setCommonin(setCommon());
          let _list: number[] = this.multipleSelection.map((item: any) => {
            return item.id;
          });
          request.setIdList(_list);
          nxExtenManageClient.delExtenPhone(
            request,
            setMetaData(),
            (err: any, response: any) => {
              if (response) {
                let data: any = response.toObject();
                let _fuc = this.delExtenPhoneFuc;
                handleResponse(data, _fuc);
                // if (!data.commonout || (data.commonout.code == 0)) {
                //   this.$message.success("删除成功!");
                //   this.getExtenList();
                // } else {
                //   this.$message.error(data.commonout.errmsg);
                // }
              }
              if (err) {
                errorMsg(err);
              }
            }
          );
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    } else {
      this.$message.warning("Pls enter the right params!!");
    }
  }
  //  lee 取消分配
  private batchUnAssignExtPhoneFuc(data: any) {
    // this.$message.success("successfully!");
    this.getExtenList();
  }
  private batchUnAssignExtPhone() {
    if (this.multipleSelection.length > 0) {
      this.$confirm(this.$tc("dashbordDy.unassign"), "tips", {
        confirmButtonText: this.$tc("ticket.Sure"),
        cancelButtonText: this.$tc("authority.cancel"),
        type: "warning"
      })
        .then(() => {
          let request: any = new UnassignReq();
          request.setCommonin(setCommon());
          let _list: number[] = this.multipleSelection.map((item: any) => {
            return item.id;
          });
          request.setIdsList(_list);
          request.setOpuid(this.userid);
          nxExtenManageClient.batchUnAssignExtPhone(
            request,
            setMetaData(),
            (err: any, response: any) => {
              if (response) {
                let data: any = response.toObject();
                let _fuc = this.batchUnAssignExtPhoneFuc;
                handleResponse(data, _fuc);
                // if (!data.commonout || (data.commonout.code == 0)) {
                //   this.$message.success("取消成功!");
                //   this.getExtenList();
                // } else {
                //   this.$message.error(data.commonout.errmsg);
                // }
              }
              if (err) {
                errorMsg(err);
              }
            }
          );
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    } else {
      this.$message.warning("Pls enter the right params!!");
    }
  }
  // lee 分配弹窗
  private assignPhoneAction(): void {
    this.isAssigned = true;
  }

  private getBasicTicketAttrs() { }
  //  lee 多選操作
  private handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }
  //  lee 分配操作，傳入ExtNumber參數
  private assignItem(item: any) {
    // var w=document.documentElement.clientWidth;
    // var h=document.documentElement.clientHeight;
    // if (w<864||h<709) {
      
    // }else{
      this.isAssigned = true;
      this.ExtNumber = item.extnumber;
      this.Supplier = item.supplier;
    // }
    
  }
  // lee 搜索操作的判断
  private testSearchForm() {
    let _bool = false;
    for (let i in this.searchForm) {
      if (this.searchForm["" + i + ""] || this.searchForm["" + i + ""] == 0) {
        _bool = true;
        return _bool;
      }
    }
  }
  //  lee 搜索操作
  private searchFormAction() {
    if (this.testSearchForm()) {
      this.isSearchFormActionDone = true;
      this.pageIndex = 1;
      this.getExtenList();
    } else {
      this.$message.warning("Pls enter the right params!!");
    }
  }
  private isNull(val: any): boolean {
    if (val) {
      return false;
    }
    return true;
  }
  // lee 获取列表
  private getExtenListFuc(data: any) {
    let _result =
      typeof data.extenlistList == "object"
        ? data.extenlistList
        : JSON.parse(data.extenlistList);
    if (_result) {
      this.pagerCount = data.pageout && data.pageout.total;
      this.resultData = _result;
    }
    // lee 接口数据通了，但是没有数据，暂时Mork一份
    // this.resultData = this.isMorked ? this.MorkResultData : _result;
    this.resultData = _result.map((item: any) => {
      item.cDate = timeFormat(Number(item.ctime));
      item.selfAssignTxt = item.assignstatus == 2 ? this.$t('Dialer.unassigned') : this.$t('Dialer.assigned');
      return item;
    });
    // 展示id、用户姓名（取nickname字段）、员工id、分机号码、分配状态、nxname、添加时间
  }
  private dwXExtenList() {
    return {
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      UserName: this.searchForm.UserName ? this.searchForm.UserName : null,
      Supplier: this.searchForm.Supplier ? +this.searchForm.Supplier : null,
      AssignStatus: (this.searchForm.AssignStatus || this.searchForm.AssignStatus == 0) ? +this.searchForm.AssignStatus : null,
      ExtNumber: this.searchForm.ExtNumber ? +this.searchForm.ExtNumber : null,
      Addstarttime: (this.searchForm.time && this.searchForm.time[0]) ? Number(this.searchForm.time[0].getTime()) : null,
      Addendtime: (this.searchForm.time && this.searchForm.time[1]) ? Number(this.searchForm.time[1].getTime()) : null,
      SearchStart: this.searchForm.SearchStart ? +this.searchForm.SearchStart : null,
      SearchEnd: this.searchForm.SearchEnd ? +this.searchForm.SearchEnd : null,
      Extuser:this.searchForm.AccountNumber//String( this.searchForm.AccountNumber?this.searchForm.AccountNumber : '',)
    }
    //   request.setPagein(setPage(this.pageIndex, this.pageSize));
    //   if (this.searchForm.UserName) {
    //     request.setUsername(this.searchForm.UserName);
    //   }
    //   // this.isNull(this.searchForm.Supplier, request.setSupplier); // 供应商
    //   if (this.searchForm.Supplier) {
    //     request.setSupplier(Number(this.searchForm.Supplier));
    //   }
    //   if (this.searchForm.AssignStatus || this.searchForm.AssignStatus == 0) {
    //     request.setAssignstatus(Number(this.searchForm.AssignStatus));
    //   } // 分配状态
    //   if (this.searchForm.ExtNumber) {
    //     request.setExtnumber(Number(this.searchForm.ExtNumber));
    //   } // 分机号码
    //   if (this.searchForm.time && this.searchForm.time[0]) {
    //     request.setAddstarttime(Number(this.searchForm.time[0].getTime()));
    //   }
    //   if (this.searchForm.time && this.searchForm.time[1]) {
    //     request.setAddendtime(Number(this.searchForm.time[1].getTime()));
    //   }
    //   if (this.searchForm.SearchStart) {
    //     request.setSearchstart(Number(this.searchForm.SearchStart));
    //   } // 分机号开始范围
    //   if (this.searchForm.SearchEnd) {
    //     request.setSearchend(Number(this.searchForm.SearchEnd));
    //   } // 分机号结束范围
  }
  private async getExtenList() {
    const { setExtenListReq, getXExtenListRequest }: any = await import("@/request/getNxteleList");
    let res = await getXExtenListRequest.handleHttp(setExtenListReq(this.dwXExtenList()), null);
    if (res && res.right) {
      let _result =
              typeof res.extenlistList == "object"
                      ? res.extenlistList
                      : JSON.parse(res.extenlistList);
      if (_result) {
        this.pagerCount = res.pageout && res.pageout.total;
        this.resultData = _result;
      }
      // lee 接口数据通了，但是没有数据，暂时Mork一份
      // this.resultData = this.isMorked ? this.MorkResultData : _result;
      this.resultData = _result.map((item: any) => {
        item.cDate = timeFormat(Number(item.ctime));
        item.selfAssignTxt = item.assignstatus == 2 ? this.$t('Dialer.unassigned') : this.$t('Dialer.assigned');
        
        return item;
      });
    }
    this.isSearchFormActionDone = false;
  }
  // private getExtenList() {
  //   let request: any = new XExtenListReq();
  //   request.setCommonin(setCommon());
  //   request.setPagein(setPage(this.pageIndex, this.pageSize));
  //   if (this.searchForm.UserName) {
  //     request.setUsername(this.searchForm.UserName);
  //   }
  //   // this.isNull(this.searchForm.Supplier, request.setSupplier); // 供应商
  //   if (this.searchForm.Supplier) {
  //     request.setSupplier(Number(this.searchForm.Supplier));
  //   }
  //   if (this.searchForm.AssignStatus || this.searchForm.AssignStatus == 0) {
  //     request.setAssignstatus(Number(this.searchForm.AssignStatus));
  //   } // 分配状态
  //   if (this.searchForm.ExtNumber) {
  //     request.setExtnumber(Number(this.searchForm.ExtNumber));
  //   } // 分机号码
  //   if (this.searchForm.time && this.searchForm.time[0]) {
  //     request.setAddstarttime(Number(this.searchForm.time[0].getTime()));
  //   }
  //   if (this.searchForm.time && this.searchForm.time[1]) {
  //     request.setAddendtime(Number(this.searchForm.time[1].getTime()));
  //   }
  //   if (this.searchForm.SearchStart) {
  //     request.setSearchstart(Number(this.searchForm.SearchStart));
  //   } // 分机号开始范围
  //   if (this.searchForm.SearchEnd) {
  //     request.setSearchend(Number(this.searchForm.SearchEnd));
  //   } // 分机号结束范围
  //   nxExtenManageClient.getExtenList(
  //     request,
  //     setMetaData(),
  //     (err: any, response: any) => {
  //       if (response) {
  //         let data: any = response.toObject();
  //         let _fuc = this.getExtenListFuc;
  //         handleResponse(data, _fuc);
  //         // if (!data.commonout || (data.commonout.code == 0)) {
  //         //   let _result =
  //         //     typeof data.extenlistList == "object"
  //         //       ? data.extenlistList
  //         //       : JSON.parse(data.extenlistList);
  //         //   if (_result) {
  //         //     this.pagerCount = data.pageout && data.pageout.total;
  //         //     this.resultData = _result;
  //         //   }
  //         //   // lee 接口数据通了，但是没有数据，暂时Mork一份
  //         //   // this.resultData = this.isMorked ? this.MorkResultData : _result;
  //         //   this.resultData = _result.map((item: any) => {
  //         //     item.cDate = timeFormat(Number(item.ctime));
  //         //     item.selfAssignTxt = item.assignstatus == 2 ? "未分配" : "已分配";
  //         //     return item;
  //         //   });
  //         //   // 展示id、用户姓名（取nickname字段）、员工id、分机号码、分配状态、nxname、添加时间
  //         // } else {
  //         //   this.$message.error(data.commonout.errmsg);
  //         // }
  //       }
  //       if (err) {
  //         errorMsg(err);
  //       }
  //       this.isSearchFormActionDone = false;
  //     }
  //   );
  // }

  // lee 添加分机号码
  // 没有必传 任意搜哪一个都行
  private testAddExtenPhoneForm(): boolean {
    return true;
  }
  //  lee 跳转分配历史
  private assignHistory(val: any) {
    this.$router.push({
      name: "分配历史",
      params: {
        item: JSON.stringify({
          SuplierType: val.supplier,
          ExtNumber: val.extnumber
        })
      }
    });
  }

  private userAssignedListFuc(data: any) { }
  private userAssignedList() {
    let request: any = new UserAssignedListReq();
    request.setCommonin(setCommon());
    // request.setToken(this.token);
    request.setUsername();
    request.setEmail();
    request.setRole();
    nxExtenManageClient.userAssignedList(
      request,
      setMetaData(),
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          let _fuc = this.userAssignedListFuc;
          handleResponse(data, _fuc);
          // if (!data.commonout || (data.commonout.code == 0)) {
          // } else {
          //   this.$message.error(data.commonout.errmsg);
          // }
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }

  private operateNxteleFuc(data: any) { }
  private operateNxtele() {
    let request: any = new OperateNxteleReq();
    request.setCommonin(setCommon());
    request.setOperate(); // 0, 1, 2, 3
    request.setId(Number());
    request.setName();
    request.setAppkey();
    request.setSecretkey();
    nxExtenManageClient.operateNxtele(
      request,
      setMetaData(),
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          let _fuc = this.operateNxteleFuc;
          handleResponse(data, _fuc);
          // if (!data.commonout || (data.commonout.code == 0)) {
          // } else {
          //   this.$message.error(data.commonout.errmsg);
          // }
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }
}
